import LoginCallbackPage from './LoginCallbackPage';
export default LoginCallbackPage;
